module.exports = __WEBPACK_EXTERNAL_MODULE_57__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/animation/dist/mdc.animation","commonjs2":"@material/animation/dist/mdc.animation","commonjs":"@material/animation/dist/mdc.animation","amd":"@material/animation/dist/mdc.animation","umd":"@material/animation/dist/mdc.animation"}
// module id = 57
// module chunks = 0